import createClient from '../../apolloClient';
import QUERY_ESIM_HISTORIES from '../../query/esimHistories';

const fetchEsimHistories = async (variables) => {
  const client = createClient();
  const result = await client.query({
    query: QUERY_ESIM_HISTORIES,
    variables,
  });
  const { esimHistories } = result?.data || {};
  if (!esimHistories?.isSuccess) throw esimHistories.message;
  return esimHistories.audits;
};

export default fetchEsimHistories;
